import React, { useState } from "react";
import RequestHandler from "util/RequestHandler";
import MonthlyBankBasedTransactionReport from "./MonthlyBankBasedTransactionReport";
import DailyBankBasedTransactionReport from "./DailyBankBasedTransactionReport";
import config from "util/ApiforContext";

import { Tabs, Col, Row, Tooltip, message } from "antd";
import { BarsOutlined, FileExcelOutlined } from "@ant-design/icons";
import OperationTypeMonthlyBankBasedTransactionReport from "./OperationTypeMonthlyBankBasedTransactionReport";
import OperationTypeDailyBankBasedTransactionReport from "./OperationTypeDailyBankBasedTransactionReport";
const { TabPane } = Tabs;

const BankBasedTransactionReport = () => {
  const [activeTabKey, setActiveTabKey] = useState("1");
  const [reportFilters, setReportFilters] = useState({
    daily: {},
    monthly: {},
    operationTypeDaily: {},
    operationTypeMonthly: {}
  });

  const onClickExportExcel = () => {
    const hideMessage = message.loading("Excel indiriliyor...", 0);

    if (activeTabKey === "1") {
      RequestHandler.post("/Reports/MonthlyBankBasedTransactionReportExportExcel",
        reportFilters.monthly
      ).then((response) => {
        hideMessage();

        if (response.success) {
          window.open(
            `${config.apiUrl}/Reports/MonthlyBankBasedTransactionReportDownloadExcel?fileName=${response.data}&t=${RequestHandler.getToken()}`
          );
        }
      });
    }
    else if(activeTabKey === "2") {
      RequestHandler.post("/Reports/DailyBankBasedTransactionReportExportExcel",
        reportFilters.daily
      ).then((response) => {
        hideMessage();

        if (response.success) {
          window.open(
            `${config.apiUrl}/Reports/DailyBankBasedTransactionReportDownloadExcel?fileName=${response.data}&t=${RequestHandler.getToken()}`
          );
        }
      });
    }
    else if(activeTabKey === "3") {
      RequestHandler.post("/Reports/OperationTypeDailyBankBasedTransactionReportExportExcel",
        reportFilters.operationTypeDaily
      ).then((response) => {
        hideMessage();

        if (response.success) {
          window.open(
            `${config.apiUrl}/Reports/OperationTypeDailyBankBasedTransactionReportDownloadExcel?fileName=${response.data}&t=${RequestHandler.getToken()}`
          );
        }
      });
    }
    else if(activeTabKey === "4") {
      RequestHandler.post("/Reports/OperationTypeMonthlyBankBasedTransactionReportExportExcel",
        reportFilters.operationTypeMonthly
      ).then((response) => {
        hideMessage();

        if (response.success) {
          window.open(
            `${config.apiUrl}/Reports/OperationTypeMonthlyBankBasedTransactionReportDownloadExcel?fileName=${response.data}&t=${RequestHandler.getToken()}`
          );
        }
      });
    }
  };

  const onMonthlyFilterChange = (filterData) => {
    setReportFilters({ ...filterData, monthly: filterData });
  };

  const onDailyFilterChange = (filterData) => {
    setReportFilters({ ...reportFilters, daily: filterData });
  };

  const onOperationTypeMonthlyFilterChange = (filterData) => {
    setReportFilters({ ...filterData, operationTypeMonthly: filterData });
  };

  const onOperationTypeDailyFilterChange = (filterData) => {
    setReportFilters({ ...reportFilters, operationTypeDaily: filterData });
  };

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> BANKA BAZLI HAREKET
          </p>
        </Col>
        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>
          <Tooltip title="Excel İndir">
            <a
              style={{
                color: "green",
                fontSize: "180%",
                marginRight: 30,
              }}
              onClick={onClickExportExcel}
            >
              <FileExcelOutlined />
            </a>
          </Tooltip>
        </Col>
      </Row>

      <Tabs
        defaultActiveKey="1"
        onChange={(activeKey) => {
          setActiveTabKey(activeKey);
        }}
      >
        <TabPane tab="Ay Bazlı" key="1">
          <MonthlyBankBasedTransactionReport onFilterChange={onMonthlyFilterChange} />
        </TabPane>
        <TabPane tab="Gün Bazlı" key="2">
          <DailyBankBasedTransactionReport onFilterChange={onDailyFilterChange} />
        </TabPane>
        <TabPane tab="İşlem Tipi Gün Bazlı" key="3">
          <OperationTypeDailyBankBasedTransactionReport onFilterChange={onOperationTypeDailyFilterChange} />
        </TabPane>
        <TabPane tab="İşlem Tipi Ay Bazlı" key="4">
          <OperationTypeMonthlyBankBasedTransactionReport onFilterChange={onOperationTypeMonthlyFilterChange} />
        </TabPane>
      </Tabs>
    </>
  );
};

export default BankBasedTransactionReport;
